import script from "./cover-thumb.vue?vue&type=script&lang=tsx"
export * from "./cover-thumb.vue?vue&type=script&lang=tsx"

const __exports__ = script;

export default __exports__